require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-reghthuys-van-wulven.json") })
        }
      }, "path---projecten-reghthuys-van-wulven");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-reghthuys-van-wulven!./.cache/json/projecten-reghthuys-van-wulven.json
// module id = 439
// module chunks = 231608221292675